import trackElementSettingsDialogDisplayed from './track-element-settings-dialog-displayed';
import trackElementSettingsDialogSubmitted from './track-element-settings-dialog-submitted';
import trackElementSettingsDialogCanceled from './track-element-settings-dialog-canceled';
import trackElementSettingsTabChanged from './track-element-settings-tab-changed';
import trackElementSettingsControlClicked from './track-element-settings-control-clicked';
import trackElementSettingsToggleClicked from './track-element-settings-toggle-clicked';
import trackElementSettingsInputClicked from './track-element-settings-input-clicked';
import trackEditingViewSelectClicked from './track-editing-view-select-clicked';
import trackEditingViewBreakpointSwitched from './track-editing-view-breakpoint-switched';

export default {
  trackElementSettingsDialogDisplayed,
  trackElementSettingsDialogSubmitted,
  trackElementSettingsDialogCanceled,
  trackElementSettingsTabChanged,
  trackElementSettingsControlClicked,
  trackElementSettingsToggleClicked,
  trackElementSettingsInputClicked,
  trackEditingViewSelectClicked,
  trackEditingViewBreakpointSwitched,
};
